/**
 * @param {CookieConsent.CookieValue} cookie
 */
export function handleConsent(cookie) {
    window.gtag &&
        window.gtag("consent", "update", {
            // Analytics cookie category
            analytics_storage: cookie.categories.includes("analytics") ? "granted" : "denied",

            // Marketing cookie category
            ad_storage: cookie.categories.includes("marketing") ? "granted" : "denied",
            personalization_storage: cookie.categories.includes("marketing") ? "granted" : "denied",
            ad_personalization: cookie.categories.includes("marketing") ? "granted" : "denied",
            ad_user_data: cookie.categories.includes("marketing") ? "granted" : "denied",
        });

    window.gtag_queue.loaded = true;
    window.gtag_queue.process();
}
